export default __webpack_public_path__ + "static/media/logo.cae06d4d.svg";